
export enum SessionType { 
    video = 1,
    audio = 2,
    im = 4,
    faceToFace = 8
}

